module.exports = __webpack_public_path__ + "static/Marriott.8592690f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Marriott.svg
// module id = 431
// module chunks = 35783957827783